export const PROVIDER_TITLES = {
  'Dr.': 'userTitles.Dr',
  'Mr.': 'userTitles.Mr',
  'Mrs.': 'userTitles.Mrs',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Miss: 'userTitles.Miss',
  'Ms.': 'userTitles.Ms',
  'Mx.': 'userTitles.Mx',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Other: 'userTitles.Other',
} as const;

export const PROVIDER_TITLE_KEYS = Object.keys(
  PROVIDER_TITLES,
) as ProviderTitleKey[];

export type ProviderTitle = typeof PROVIDER_TITLES;
export type ProviderTitleKey = keyof ProviderTitle;
